import { Component, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { Customer, CustomerGridViewModel } from "../../parties/model/customer.model";
import { filter, take, takeUntil } from "rxjs/operators";
import { form_control } from "projects/sepidz-web-framework/src/lib/models/form-control.model";
import { CustomerDetailsEnum } from "../model/customerdetailenum";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { NotificationService } from "projects/sepidz-web-framework/src/lib/services/notification.service";
import { CallRead } from "../model/call-read.model";
import { GridFilter, PagingDataResult } from "projects/sepidz-web-framework/src/lib/services";
import { CustomerFormComponent } from "../../parties/customer/customer-form.component";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { CustomerLoadModel, CustomerOrderService } from "./customerorder.service";
import { ColumnBase } from "@progress/kendo-angular-grid";
import { GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
// import { InvoiceService } from "../orderpage/invoice/invoice.service";

@Component({
  selector: "order-customer",
  templateUrl: "./customerorder.component.html",
  styleUrls: ["./customerorder.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerOrderComponent extends BaseListComponent implements OnDestroy {
  currentData: PagingDataResult<CustomerGridViewModel> = new PagingDataResult<CustomerGridViewModel>();
  _customers: CustomerGridViewModel[];
  isShowGrid: boolean = true;
  calls: CallRead[] = [];
  customerId: number;
  CurrentCallNumber: string = "";
  currentGridFilter: GridFilter[];
  hasCallerIdNumber: boolean = false;
  @ViewChild("kgrid") grid: KGridComponent;

  constructor(
    public dialog: SimpleModalService,
    public customerOrder: CustomerOrderService,
    private cd: ChangeDetectorRef,
    private customerService: CustomerOrderService,
    private notification: NotificationService,
    private splashFormService: SplashFormService // private invoiceService: InvoiceService
  ) {
    super();
    this.NoLog = true;
    this.inputEditorform = CustomerFormComponent;
    this.CurrentCallNumber = "";
    this.customerOrder.CallerIdNumber = "";
  }

  ngOnInit() {
    this.areaName = "RestaurantSale";
    this.apiName = "Customer/GetCustomers";
    this.init();
    this.FillData();
    this.ReadListCallerIdNotification();
  }

  FillData() {
    this._customers = [];
    this.customerOrder.currentCustomerDetailsEnum = CustomerDetailsEnum.Details;
    this.getcolumns();
  }

  private ReadListCallerIdNotification() {
    if (this.calls && this.calls.length > 0) return;
    this.httpCommonService
      .getList(`CallerId/ReadList/${this.customerOrder.order.logInBranch.Id}`)
      .pipe(take(1))
      .subscribe((data) => {
        if (data) {
          this.calls = (data as CallRead[]).sort((a, b) => Number(a.Line) - Number(b.Line));
          this.cd.markForCheck();
        }
      });
  }
  private init(): void {
    this.CurrentCallNumber = undefined;
    this.notification.init();
    this.notification.notification$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      if (value.Key === "CallerIdNotification") {
        this.calls = value.Message.sort((a, b) => Number(a.Line) - Number(b.Line));
        this.cd.markForCheck();
      }
    });
  }
  getcolumns() {
    this.httpCommonService
      .getControlsList("Customer")
      .pipe(take(1))
      .subscribe((data) => {
        if (data) {
          this.columns = (data as form_control[]).sort((a, b) => a.order - b.order);
        }
        this.cd.markForCheck();
      });
  }
  answer(call: CallRead) {
    this.CurrentCallNumber = call.Number?.length > 10 ? call.Number.substring(call.Number.length - 10, call.Number.length) : call.Number;
    this.customerService.CallerIdNumber = call.Number?.length > 10 ? call.Number.substring(call.Number.length - 10, call.Number.length) : call.Number;
    if (!this.currentGridFilter) this.currentGridFilter = [];
    const CallerIdNumber: string = call.Number?.length > 10 ? call.Number.substring(call.Number.length - 10, call.Number.length) : call.Number;
    this.grid.isRefreshing = false;
    this.customerOrder.group.controls["Numbers"].setValue(CallerIdNumber);
    this.currentGridFilter.push({ Filed: "PhoneNumber", Type: "F", Value: CallerIdNumber, Operator: "eq", Logic: "and", Skip: 0, Take: 10 });
    this.httpCommonService
      .create("CallerId/Answer", { Id: call.Id })
      .pipe(take(1))
      .subscribe(() => {
        this.hasCallerIdNumber = true;
      });
  }
  onGetDataComplete($event) {
    if ($event && this.CurrentCallNumber !== undefined && this.hasCallerIdNumber) {
      if ($event.length === 1) {
        if ($event[0].Number !== 0) {
          this.customerId = $event[0].Id;
          if (!this.customerOrder.currentCustomer || this.customerOrder.currentCustomer.Id !== this.customerId)
            this.customerOrder.GetCustomerDetails(this.customerId, true, this.CurrentCallNumber);
          else this.customerOrder.setCostomerInfo();
        } else {
          this.hasCallerIdNumber = false;
          return;
        }
      } else {
        this.currentGridFilter = null;
        this.currentGridFilter = [];
        this.currentGridFilter.push({ Filed: "Party.Number", Type: "F", Value: 0, Operator: "eq", Logic: "and", Skip: 0, Take: 10 });
        return;
      }
    }
    if (!this.hasCallerIdNumber) this.currentGridFilter = null;
    this.hasCallerIdNumber = false;
  }
  onDataStateChanged(event: GridFilter[]) {
    this.currentGridFilter = event;
  }

  //انتخاب یک سطر از لیست مشترکین جهت نمایش جزئیات
  getRowSelectedData(data: Customer) {
    this.customerOrder.currentCustomerDetailsEnum = CustomerDetailsEnum.Details;
    if (!this.customerId || this.customerId !== data.Id) this.customerId = data.Id;
    this.customerOrder.GetCustomerDetails(data.Id);
  }
  //پرکردن اطلاعات مشتری در فاکتور با دابل کلیک برروی ردیف ورفتن به صفحه فاکتور
  onDoubleClick(customer?: Customer) {
    this.splashFormService.openDialog();
    this.customerOrder.customerDetailsIsLoaded$
      .pipe(
        takeUntil(this.ngUnsubscribe),
        filter((customerLoadModel: CustomerLoadModel) => customerLoadModel.type === "Loaded" && customerLoadModel.customerId === customer.Id),
        take(1)
      )
      .subscribe(() => {
        this.customerOrder.doubleClickUnsubscribe$.next();
        this.customerId = customer?.Id;
        this.customerOrder.setCostomerInfo();

        this.customerOrder.order.calculate();
        this.splashFormService.closeLoading();
        this.clearFilters();
      });
  }
  //پرکردن فیلد آدرس انتخاب شده
  FillSelectedAddressId(event) {
    this.customerOrder.currentCustomer.SelectedAddressId = event;
  }
  //پر کردن فیلد تلفن انتخاب شده
  FillSelectedPhoneId(event) {
    this.customerOrder.currentCustomer.SelectedPhoneId = event;
  }
  onEdit($event) {
    this.dialogService
      .open(
        this.inputEditorform,
        { currentrow: $event, apiName: this.apiName, areaName: this.areaName, label: this.label },
        { autoFocus: true, closeOnClickOutside: false, closeOnEscape: false }
      )
      .pipe(take(1))
      .subscribe((_model: Customer) => {
        this.grid?.refreshData();
      });
  }

  getParamsForExportExcelWithPostMethod(): Promise<any> {
    return new Promise((resolve, reject) => {
      resolve(this.getGridInfo(this.grid.grid.columns.toArray()));
    });
  }

  getGridInfo(columns: ColumnBase[]): GridColumnInfoDetail[] {
    return columns
      .filter((x) => !x.hidden)
      .map((x) => {
        const info = new GridColumnInfoDetail();
        info.name = x["field"];
        info.hidden = x.hidden;
        info.orderindex = x.orderIndex;
        info.title = x.title;
        return info;
      });
  }

  clearFilters() {
    const filterService = this.grid.grid["filterService"];

    if (filterService) {
      filterService.filter({
        logic: "and",
        filters: [],
      });
    }
  }
}
